
Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.BarGauge = void 0;

var _react = _interopRequireDefault(require('react'));

var _propTypes = _interopRequireDefault(require('prop-types'));

var _styledComponents = require('styled-components');

var _Text = require('../Text');

var _colors = require('../../utils/colors');

var _BarGauge = require('./BarGauge.styled');

var _ProgressBar = require('../ProgressBar');

var _ProgressBar2 = require('../ProgressBar/ProgressBar');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _extends() {
  var _extendsInner = function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extendsInner.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var BarGauge = function BarGauge(props) {
  var heading = props.heading,
    value = props.value,
    maxValue = props.maxValue,
    description = props.description,
    theme = props.theme,
    colorMapping = props.colorMapping,
    leftLabel = props.leftLabel,
    rightLabel = props.rightLabel,
    rest = _objectWithoutProperties(props, [
      'heading',
      'value',
      'maxValue',
      'description',
      'theme',
      'colorMapping',
      'leftLabel',
      'rightLabel'
    ]);

  return _react.default.createElement(
    _react.default.Fragment,
    null,
    _react.default.createElement(
      _BarGauge.StyledLabelsContainer,
      null,
      _react.default.createElement(
        _BarGauge.StyledHeadingText,
        {
          marginRight: '10px',
          level: 'h6',
          fontWeight: '500'
        },
        heading
      ),
      _react.default.createElement(
        _BarGauge.StyledHeadingText,
        {
          marginRight: '5px',
          level: 'h6'
        },
        value && value.toString()
      ),
      _react.default.createElement(
        _Text.Text,
        {
          color: (0, _colors.getRGBOpacity)(theme.colors.primaryFont, 0.5)
        },
        _react.default.createElement(_react.default.Fragment, null, description, ' ', maxValue)
      )
    ),
    _react.default.createElement(
      _ProgressBar.ProgressBar,
      _extends(
        {
          value: value,
          maxValue: maxValue,
          colorMapping: colorMapping,
          justifyLabels: 'space-between'
        },
        rest
      ),
      _react.default.createElement(
        _BarGauge.StyledGaugeLabel,
        {
          level: 'xxSmall'
        },
        leftLabel
      ),
      _react.default.createElement(
        _BarGauge.StyledGaugeLabel,
        {
          level: 'xxSmall',
          position: 'right'
        },
        rightLabel
      )
    )
  );
};

var BarGaugeWrapper = (0, _styledComponents.withTheme)(BarGauge);
exports.BarGauge = BarGaugeWrapper;
BarGauge.defaultProps = {
  maxValue: 100,
  description: '',
  containerColor: '',
  colorMapping: [],
  leftLabel: '',
  rightLabel: '',
  theme: {}
};
BarGauge.propTypes = {
  heading: _propTypes.default.string.isRequired,
  value: _propTypes.default.number.isRequired,
  maxValue: _propTypes.default.number,
  description: _propTypes.default.string,
  containerColor: _propTypes.default.string,
  leftLabel: _propTypes.default.string,
  rightLabel: _propTypes.default.string,
  colorMapping: _propTypes.default.arrayOf(_ProgressBar2.ProgressBarColorMapping),
  theme: _propTypes.default.any
};
